module.exports = __webpack_public_path__ + "img/wiggle07.f2e30921.jpg";